/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Page, IUser, IUserDetails } from "../../models/Users/UserContracts";
import { IRole } from "../../models/Roles/RolesContracts";
import {
  GET_ALL_USERS,
  RESET_USERS,
  SET_FILTERED_USERS,
  SET_NO_ITEM,
  SET_SEARCH_VALUE,
  SET_SELECTED_USER,
  SET_SELECTED_USER_DETAILS,
  RESET_SELECTED_USER_DETAILS,
  SET_IDPS,
  SET_SEARCH_KEY,
  SET_IDP_ROLES,
  SET_ROLES_TO_ASSIGN
} from "./types";

export const getAllUsersAction = (users: IUser[], filteredUsers: IUser[], selectedItem: IUser, page: Page) => {
  return {
    type: GET_ALL_USERS,
    users,
    filteredUsers,
    selectedItem,
    page
  };
};

export const setSelectedUserAction = (selectedItem: IUser) => {
  return {
    type: SET_SELECTED_USER,
    selectedItem,
  };
};

export const setSelectedUserDetailsAction = (selectedItemDetails: IUserDetails) => {
  return {
    type: SET_SELECTED_USER_DETAILS,
    selectedItemDetails,
  };
};

export const resetSelectedUserDetailsAction = () => {
  return {
    type: RESET_SELECTED_USER_DETAILS
  };
};

export const setFilteredUserAction = (filteredUsers: IUser[], selectedItem: IUser, page: Page) => {
  return {
    type: SET_FILTERED_USERS,
    filteredUsers,
    selectedItem,
    page
  };
};

export const setNoItemAction = (users: IUser[], filteredUsers: IUser[], noItem: boolean) => {
  return {
    type: SET_NO_ITEM,
    users: users,
    filteredUsers: filteredUsers,
    noItem
  };
};
export const setSearchUser = (searchValue?: string) => {
  return {
    type: SET_SEARCH_VALUE,
    searchValue
  };
};
export const setSearchKey= (searchKey?: string) => {
  return {
    type: SET_SEARCH_KEY,
    searchKey
  };
};
export const resetUsersState = () => {
  return {
    type: RESET_USERS
  };
};

export const setIdps = (idps:any) => {
  return {
    type: SET_IDPS,
    idps
  };
};
export const setIdpRoles = (idpRoles:any) => {
  return {
    type: SET_IDP_ROLES,
    idpRoles
  };
};

export const setRolesToAssign = (roles: IRole[]) => {
  return {
    type: SET_ROLES_TO_ASSIGN,
    rolesToAssign: roles
  };
};
